<template>
  <div>
    <common-header title="설문조사" :showTitle="true" :showCart="false" :showHome="true" :showBack="false"/>
    <main class="survey_q_bg content">
      <div class="content">
        설문조사에 참여해주셔서 감사합니다.<br/>
        <br/>
        더 좋은 서비스로 보답하겠습니다.<br/>
      </div>
      <div>
        <button type="button" class="btn btn-full btn-primary footer-bottom" @click="changeSurveyMainView">돌아가기</button>
      </div>
    </main>
  </div>
</template>

<script>
import {YN} from "../AppConstants";

export default {
  methods: {
    changeSurveyMainView() {
      // 설문조사 리스트 화면으로 이동
      this.$router.push({
        path: '/',
        query: {answerYn: YN.Y}
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/SurveyComplete.vue